import React from 'react'
import { AsH3, EyebrowMD, ParagraphMD, ParagraphSM } from '@/atoms/Text'

type MediaDesciptorsProps = {
  title?: string
  subtitle?: string
  displayDescription?: boolean
  description?: string
  href: string
}

export const MediaDescriptors: React.FC<MediaDesciptorsProps> = ({
  title,
  subtitle,
  displayDescription,
  description,
  href,
}) => {
  return (
    <>
      {title && (
        <EyebrowMD
          weight="bold"
          color="core-gray-600"
          className="block overflow-x-hidden text-ellipsis whitespace-nowrap"
        >
          {title}
        </EyebrowMD>
      )}
      {subtitle && (
        <ParagraphMD as={AsH3} aria-label={title} className="my-1 overflow-x-hidden text-ellipsis whitespace-nowrap">
          {subtitle}
        </ParagraphMD>
      )}
      {displayDescription && description && (
        <ParagraphSM
          aria-label={href.includes('/community/stories') ? 'video-story-description' : 'episode-description'}
          className="line-clamp-4 text-core-gray-500"
        >
          {description}
        </ParagraphSM>
      )}
    </>
  )
}
